import { ChildTask } from '@dynamika-shared/types/reader';
import { TASK_STATUSES } from './constants';

const ELIGIBLE_STATUSES = [
  TASK_STATUSES.READING_PENDING,
  TASK_STATUSES.IN_PROGRESS,
];

export const findNextEligibleSubTask = (
  childTasks: ChildTask[] | undefined,
  currentSubTaskId: string
): ChildTask | null | undefined => {
  const sortedSubTasks = [...(childTasks ?? [])].sort(
    (a, b) => a.visitOrder - b.visitOrder
  );

  const currentSubTask = sortedSubTasks.find(
    subTask => subTask.id === currentSubTaskId
  );

  if (!currentSubTask) {
    return undefined;
  }

  return (
    sortedSubTasks.find(
      subTask =>
        subTask.visitOrder > currentSubTask.visitOrder &&
        ELIGIBLE_STATUSES.includes(subTask.status)
    ) ?? null
  );
};
